export const UpdateCartStore = (payload) => {
  return {
    type: '@updateCart',
    payload: payload,
  };
};

export const cartReducer = (state = {}, action) => {
  switch (action.type) {
    case '@updateCart':
      state.cart = action.payload;
      break;
    default:
      break;
  }
};
